import React from 'react';
import BookingsManagement from './BookingsManagement';

const ApprovedBookings = () => {
  return <BookingsManagement filter="approved" />;
};

export default ApprovedBookings;
